import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { movieBookingApi } from '../../services/movieBookingApi';
import './MovieBooking.css';

const getLocalDateString = () => {
  const now = new Date();
  const offsetMs = now.getTimezoneOffset() * 60 * 1000;
  return new Date(now.getTime() - offsetMs).toISOString().slice(0, 10);
};

const MoviesBrowse = ({ onSwitchRole }) => {
  const [movies, setMovies] = useState([]);
  const [search, setSearch] = useState('');
  const [cityInput, setCityInput] = useState('Bangalore');
  const [dateInput, setDateInput] = useState(() => getLocalDateString());
  const [appliedCity, setAppliedCity] = useState('Bangalore');
  const [appliedDate, setAppliedDate] = useState(() => getLocalDateString());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMovies = async () => {
      try {
        const response = await movieBookingApi.getMovies();
        setMovies(response.data || []);
      } catch (error) {
        setMovies([]);
      } finally {
        setLoading(false);
      }
    };
    loadMovies();
  }, []);

  const filteredMovies = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return movies;
    return movies.filter((movie) => movie.title?.toLowerCase().includes(term));
  }, [movies, search]);

  return (
    <div className="movie-booking-page">
      <div className="movie-booking-header">
        <div>
          <h1 className="movie-booking-title">Movie Booking</h1>
          <p className="movie-booking-note">Choose a movie, city, and showtime to book your seats.</p>
        </div>
        <button className="movie-booking-button secondary" onClick={onSwitchRole}>
          Switch Role
        </button>
      </div>

      <div className="movie-booking-card">
        <h3>Find shows in your city</h3>
        <p className="movie-booking-note">
          Results use city and date selected below.
        </p>
        <div className="movie-booking-form">
          <input
            className="movie-booking-input"
            placeholder="Search movie title"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <input
            className="movie-booking-input"
            placeholder="City"
            value={cityInput}
            onChange={(event) => setCityInput(event.target.value)}
          />
          <input
            className="movie-booking-input"
            type="date"
            value={dateInput}
            onChange={(event) => setDateInput(event.target.value)}
          />
          <button
            type="button"
            className="movie-booking-button"
            onClick={() => {
              setAppliedCity(cityInput.trim() || 'Bangalore');
              setAppliedDate(dateInput || getLocalDateString());
            }}
          >
            Search Showtimes
          </button>
        </div>
      </div>

      {loading && <p>Loading movies...</p>}
      {!loading && (
        <div className="movie-booking-card-grid">
          {filteredMovies.map((movie) => (
            <div key={movie.id} className="movie-booking-card">
              <h3>{movie.title || 'Untitled Movie'}</h3>
              <p className="movie-booking-note">{movie.genre || 'Genre not set'}</p>
              <div className="movie-booking-actions">
                <Link
                  to={`/movies/${movie.id}/shows?city=${encodeURIComponent(appliedCity)}&date=${encodeURIComponent(appliedDate)}`}
                  className="movie-booking-button"
                >
                  View Showtimes
                </Link>
              </div>
            </div>
          ))}
          {!filteredMovies.length && <p>No movies found.</p>}
        </div>
      )}
    </div>
  );
};

export default MoviesBrowse;
